$(document).ready(function($) {
    $('.higlight__slides').slick({ speed: 800, arrows: false });
});

$(document).on('mouseenter', '.highlight__thumbnails li', function(event) {
    var num = $(this).index();
    $('.higlight__slides').slick('slickGoTo', num, true);
});
